// import { useState } from "react";
import { Checkbox } from "@/components/ui/checkbox"
import { useFieldContext } from "@/features/question/components/organisms/FieldRenderer";
// import { FieldOptions } from "@/types/crm/tables/question";
import { useEffect, useState } from "react";

export function RadioRenderer() {
    const { question, setFormValue, disabled, response, currentValue } = useFieldContext();
    const [value, setValue] = useState<string | undefined>(undefined);

    useEffect(() => {
        if(currentValue) {
            setValue(currentValue);
        }
    }, [currentValue]);

    useEffect(() => {
        if (!disabled && setFormValue) {
            setFormValue(value);
        }
    }, [setFormValue, value, disabled]);

    if (!Array.isArray(question.field_options)) {
        return (
            <div className="flex flex-col flex-wrap gap-2">
                {question?.field_options?.options.map((option) => {
                    if (typeof option === 'string') {
                        option = {
                            value: option,
                            label: option
                        }
                    }
                    return (
                        <div key={option.value} className="flex items-center space-x-2">
                            <Checkbox
                                id={option.value}
                                value={option.value}
                                checked={!disabled ? value === option.value : response?.field_value === option.value}
                                onClick={() => {
                                    setValue(option.value);
                                }}
                                className="w-5 h-5 form-checkbox text-primary"
                                disabled={disabled}
                            />
                            <label htmlFor={option.value} className="text-sm">{option.label}</label>
                        </div>
                    )
                })}
            </div>
        )
    }
    return (
        <div className="flex flex-col flex-wrap gap-2">
            {question?.field_options?.map((option) => {
                if (typeof option === 'string') {
                    option = {
                        value: option,
                        label: option
                    }
                }
                return (
                    <div key={option.value} className="flex items-center space-x-2">
                        <Checkbox
                            id={option.value}
                            value={option.value}
                            checked={!disabled ? value === option.value : response?.field_value === option.value}
                            onClick={() => {
                                setValue(option.value);
                            }}
                            className="w-5 h-5 form-checkbox text-primary"
                            disabled={disabled}
                        />
                        <label htmlFor={option.value} className="text-sm">{option.label}</label>
                    </div>
                )
            })}
        </div>
    )
}